import { IssueBoxContainer } from "./IssueBoxContainer";
import { IssueBoxItem } from "./IssueBoxItem";

/**
 * IssueBox 컴파운드 컴포넌트
 *
 * 새로운 컴파운드 컴포넌트 패턴을 사용하여 더 직관적인 API를 제공합니다.
 *
 * @example
 * ```tsx
 * <IssueBox.Container
 *   color="#000000"
 *   title="title"
 *   subTitle="subTitle"
 *   open={true}
 *   onToggle={(open) => console.log("open", open)}
 * >
 *   <IssueBox.Item
 *     issueId="1"
 *     name="name"
 *     category="심각도"
 *     grade={3}
 *     type="marker"
 *     updatedAt="2025-01-01"
 *     onClick={(id) => console.log("id", id)}
 *   />
 * </IssueBox.Container>
 * ```
 */
export const IssueBox = {
  Container: IssueBoxContainer,
  Item: IssueBoxItem,
};
